import React, { useState } from "react";
import {
    Card,
    CardHeader,
    CardContent,
    CardActions,
    Button,
    Typography,
    Divider,
    CircularProgress,
} from "@mui/material";

export default function CareerAIAdvisorCard({ studentData }) {
    const [loading, setLoading] = useState(false);
    const [advice, setAdvice] = useState(null);
    const [error, setError] = useState(null);

    const fetchAdvice = async () => {
        setLoading(true);
        setError(null);
        setAdvice(null);

        try {
            console.log("studentData", studentData);

            const response = await fetch(
                "http://localhost:1337/api/career-advisor",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(studentData),
                }
            );

            console.log("response", response);

            if (!response.ok) {
                const text = await response.text();
                throw new Error(text || "Błąd serwera");
            }

            const json = await response.json();

            if (!json || !json.advice) {
                throw new Error("Brak pola advice w odpowiedzi");
            }

            setAdvice(json.advice);
        } catch (err) {
            setError(err.message || "Nie udało się pobrać porady");
        } finally {
            setLoading(false);
        }
    };

    return (
        // <Card sx={{ maxWidth: 500, mx: "auto", my: 3, borderRadius: 3 }}>
        <Card sx={{ mx: "auto", my: 3, borderRadius: 3 }}>
            <CardHeader
                title="Doradca kariery"
                subheader="Analiza profilu studenta"
            />

            <Divider />

            <CardContent>
                {loading && (
                    <div style={{ display: "flex", justifyContent: "center", margin: "16px 0" }}>
                        <CircularProgress />
                    </div>
                )}

                {error && (
                    <Typography color="error" sx={{ mb: 2 }}>
                        {error}
                    </Typography>
                )}

                {advice && (
                    <Typography variant="body1" sx={{ whiteSpace: "pre-line" }}>
                        {advice}
                    </Typography>
                )}
            </CardContent>

            <CardActions>
                <Button
                    variant="contained"
                    onClick={fetchAdvice}
                    disabled={loading}
                    fullWidth
                >
                    Uzyskaj doradztwo zawodowe
                </Button>
            </CardActions>
        </Card>
    );
}
